import React, { forwardRef, useMemo } from 'react';
import { useMaskito } from '@maskito/react';
import { TextFieldNew, type TextFieldNewProps } from '../TextFieldNew';
import mergeRefs from '../utils/mergeRefs';

import options from './mask';

export const TimeField = forwardRef<HTMLInputElement, TextFieldNewProps>((props, ref) => {
  const maskedInputRef = useMaskito({ options });
  const inputRef = useMemo(() => mergeRefs([maskedInputRef, ref]), [maskedInputRef, ref]);

  return (
    <TextFieldNew
      ref={inputRef}
      onInput={(e) => props.onChange?.(e.currentTarget.value)}
      {...props}
    />
  );
});
